import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Toast, ToastsService } from '../services/toasts.service';
import { ToastComponent } from './toast/toast.component';

@Component({
  selector: 'co-toasts-container',
  templateUrl: './toasts-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'toasts' },
  standalone: true,
  imports: [CommonModule, ToastComponent]
})
export class ToastsContainerComponent {
  public readonly toasts$: Observable<Toast[]>;

  constructor(private readonly toastsService: ToastsService) {
    this.toasts$ = this.toastsService.toasts$;
  }

  public onRemove(toast: Toast): void {
    this.toastsService.remove(toast);
  }
}
